module.exports = __webpack_public_path__ + "img/CV.57245437.png";